import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,{staticClass:"fill-height",attrs:{"justify":"center"}},[_c(VCol,{attrs:{"align":"center","align-self":"center"}},[_c('h1',{staticClass:"primary--text"},[_vm._v("Sorry! Page Not Found")]),_c('h3',{staticClass:"primary--text"},[_vm._v("(Error 404)")]),_c(VImg,{attrs:{"width":"50%","contian":"","src":require("@/assets/notFound.svg")}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }